import { Component, Prop, Vue } from "vue-property-decorator";
import { LessonPlanTemplateRowsType } from "@/util/enum";

@Component({})
export default class RowsIndicatorRect extends Vue {
	@Prop() rectType!: LessonPlanTemplateRowsType;

	get rectClassName(): string {
		switch (this.rectType) {
			case LessonPlanTemplateRowsType.TeachingPlan:
				return "rect-teaching-plan-rows";
			case LessonPlanTemplateRowsType.Transition:
				return "rect-transition-rows";
			case LessonPlanTemplateRowsType.Header:
			default:
				return "rect-header-rows";
		}
	}
}
